module.exports = __webpack_public_path__ + "static/media/logo.8bc52180.svg";